import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Refresh18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 1H1.25V6.75H7V5.25H3.99425C5.47002 3.27607 8.04844 2.34016 10.4499 2.91288C13.2331 3.57665 15.2531 6.1379 15.25 8.99919L16.75 9.00082C16.7538 5.45283 14.2491 2.27688 10.7978 1.4538C7.7951 0.737675 4.57238 1.92435 2.75 4.40974V1Z'
      fill='currentColor'
    />
    <path
      d='M2.75 9.00081C2.74689 11.8621 4.76687 14.4233 7.5501 15.0871C9.95153 15.6598 12.5299 14.7239 14.0057 12.75H11V11.25H16.75V17H15.25V13.5902C13.4276 16.0756 10.2049 17.2623 7.20212 16.5462C3.75091 15.7231 1.24614 12.5472 1.25 8.99918L2.75 9.00081Z'
      fill='currentColor'
    />
  </Svg>
);

Refresh18.displayName = 'Refresh18';
export default Refresh18;
